<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h5>
            Validate SD Contact Data with Master Database ({{
              campaignDescription['campaign_name']
            }})
          </h5>
        </vs-col>
        <!-- <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button @click="finished">Finish</vs-button>
        </vs-col> -->
      </vs-row>
      <vs-row vs-w="12" class="mb-5">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
       
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>

      <vs-pagination
        :total="total_pages"
        v-model="currentx"
        goto
      ></vs-pagination>

      <template v-for="(matched_contact, key) in match_contacts">
        <vs-table stripe :key="key" :data="matched_contact" class="mt-10">
          <template slot="thead"> </template>

          <template slot-scope="{ data }">
            <vs-tr>
              <vs-td>
                <vs-button @click="acceptToUpdate(matched_contact)"
                  >Update</vs-button
                >
              </vs-td>

              <template
                v-for="(matched, value) in matched_contact['csv_contact']"
              >
                <vs-td v-if="value != 'account_contact_id'">
                  <template
                    v-for="field_array_column in selected_contact_fields"
                  >
                    <template v-if="field_array_column.id == value">
                      <h6>{{ field_array_column.name }}</h6>
                    </template>
                  </template>

                  <vs-td>
                    <template v-if="Array.isArray(matched)">
                      <template v-for="val1 in matched">

                       


                        {{ val1 }} 
                      </template>
                    </template>
                    <template v-else>
                      {{ matched }} 
                    </template>
                  </vs-td>
                </vs-td>
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </template>
      <vs-pagination
        :total="total_pages"
        v-model="currentx"
        goto
      ></vs-pagination>
    </vx-card>
    <vs-popup
      fullscreen
      style="z-index: 999999"
      class="holamundo"
      title="On the left side you can see the sd contacts and on the right side the master database contacts. The fields with different values are highlighted in grey."
      :active.sync="enrichContactDataToMasterDBPopUp"
    >
      <div class="text-center">
        <template
          v-for="(value, key) in contactDataDescription['master_db_contact']"
        >
          <vs-col>
            <template v-for="field_array_column in selected_contact_fields">
              <template v-if="field_array_column.id == key">
                <div v-if="field_array_column.identifier == 'company_name'">
                  <strong
                    ><span>Contact : {{ value }}</span></strong
                  >
                </div>
              </template>
            </template>
          </vs-col>
        </template>
       
      </div>

      <vs-row vs-w="12" class="mb-10 mt-10">
        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full"></div>

            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> SD Contacts</u></h6>
            </div>
          </div>
          <template
            v-for="(value, key) in contactDataDescription['csv_contact']"
          >
            <vs-col>
              <div
                class="vx-row mb-6"
                v-bind:class="
                  has_different_value.includes(key)
                    ? 'row-height_with_size'
                    : ''
                "
              >
                <div class="vx-col sm:w-1/2 w-full">
                  <template
                    v-for="field_array_column in selected_contact_fields"
                  >
                    <template v-if="field_array_column.id == key">
                      <span>{{ field_array_column.name }}  :</span>
                    </template>
                  </template>
                </div>

                <div class="vx-col sm:w-1/2 w-full">
                  <template
                    v-if="has_different_value.includes(key) && value != 'EMPTY'"
                    v-model="contactDataDescription['csv_contact'][key]"
                  >
                    <template
                      v-for="field_array_column in selected_contact_fields"
                    >
                      <template v-if="field_array_column.id == key">
                        <div
                          v-if="
                            field_array_column.identifier == 'none_core_field'
                          "
                        >


                        
                          <template v-if="Array.isArray(value)">
                            <template v-for="(val1, index1) in value">
                              <template
                                v-if="field_array_column.type == 'checkbox'"
                              >
                                {{ val1 }}
                              </template>

                              <template v-else> </template>

                              {{ val1 }}
                            </template>
                          </template>
                          <template v-else>
                            <div
                              v-if="
                                field_array_column.identifier ==
                                  'none_core_field' &&
                                has_different_value.includes(key)
                              "
                            >
                              {{ value }}
                            </div>
                          </template>
                        </div>
                        <template v-else>
                          <div
                            v-if="
                              field_array_column.identifier == 'mobile' ||
                              field_array_column.identifier ==
                                'contact_social_media' ||
                              field_array_column.identifier == 'ddi' ||
                              field_array_column.identifier == 'email' ||
                              field_array_column.identifier == 'role' ||
                              field_array_column.identifier == 'sub_role' ||
                              field_array_column.identifier == 'job_title'
                            "
                          >
                            <template v-if="Array.isArray(value)">
                              <template v-for="(val, index) in value">
                                {{ val }}

                                <br />
                              </template>
                            </template>
                            <template v-else>
                               <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                            </template>
                          </div>

                          <div v-else>
                            {{ value }}
                          </div>
                        </template>

                        <template v-else>

                           <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                        </template>
                      </template>
                    </template>
                  </template>

                  <template v-else>
                    <template
                      v-for="field_array_column in selected_contact_fields"
                    >
                      <template v-if="field_array_column.id == key">
                        <div
                          v-if="
                            field_array_column.identifier == 'mobile' ||
                            field_array_column.identifier ==
                              'contact_social_media' ||
                            field_array_column.identifier == 'ddi' ||
                            field_array_column.identifier == 'email' ||
                            field_array_column.identifier == 'role' ||
                            field_array_column.identifier == 'sub_role' ||
                            field_array_column.identifier == 'job_title'
                          "
                        >
                          <template v-if="Array.isArray(value)">
                            <template v-for="val1 in value">
                              {{ val1 }}

                              <br />
                            </template>
                          </template>
                          <template v-else>
                             <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                          </template>
                        </div>

                        <template v-else>
                          <div
                            v-if="
                              field_array_column.identifier ==
                                'none_core_field' &&
                              has_different_value.includes(key)
                            "
                          >


                            {{ value }}
                          </div>

                          <div v-else >

                            
                            <template v-if="Array.isArray(value)">
                              <template v-for="val in value">
                                <span class="ml-1">{{ val }} </span>
                              </template>
                            </template>

                            <template v-else>

                                                        

                               <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                            </template>
                          </div>
                        </template>
                      </template>
                    </template>
                  </template>
                </div>
              </div>
              <vs-divider class="p-5" />
            </vs-col>
          </template>
        </vs-col>

        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full"></div>

            <div class="vx-col sm:w-1/2 w-full">
              <h6><u> Master DB Contacts</u></h6>
            </div>
          </div>
          <template
            v-for="(value, key) in contactDataDescription['master_db_contact']"
          >
            <vs-col v-if="key != 'account_contact_id'">
              <div 
                class="vx-row mb-6"
                v-bind:class="
                  has_different_value.includes(key)
                    ? 'row-height_with_size'
                    : ''
                "
              >
                <div class="vx-col sm:w-1/3 w-full"></div>
                <template v-for="field_array_column in selected_contact_fields">
                  <template v-if="field_array_column.id == key">
                    <div
                      v-if="
                        field_array_column.identifier == 'role' ||
                        field_array_column.identifier == 'ddi' ||
                        field_array_column.identifier == 'sub_role' ||
                        field_array_column.identifier == 'seniority' ||
                        field_array_column.identifier == 'mobile' ||
                        field_array_column.identifier ==
                          'contact_social_media' ||
                        field_array_column.identifier == 'email'
                      "
                    >

                      <div class="vx-col w-full">
                        <template v-if="has_different_value.includes(key)">
                          <template
                            v-if="field_array_column.identifier == 'role'"
                          >
                            <v-select
                              name="role"
                              class="role"
                              label="role"
                              :options="all_roles"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              v-model="
                                contactDataDescription['master_db_contact'][key]
                              "
                            />
                          </template>

                          <template
                            v-else-if="
                              field_array_column.identifier == 'sub_role'
                            "
                          >
                            <v-select
                              name="sub_role"
                              class="sub_role"
                              label="sub_role"
                              :options="all_sub_roles"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              v-model="
                                contactDataDescription['master_db_contact'][key]
                              "
                            />
                          </template>

                          <template
                            v-else-if="
                              field_array_column.identifier == 'seniority'
                            "
                          >
                            <div class="vx-col sm:w-1/3 w-full">
                              <v-select
                                label="seniority"
                                :options="all_seniorities"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                v-model="
                                  contactDataDescription['master_db_contact'][
                                    key
                                  ]
                                "
                              />
                            </div>
                          </template>

                          <template
                            v-else-if="field_array_column.identifier == 'ddi'"
                          >


                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                              <div class="flex mb-4">
                                <div
                                  class="w-1/3 bg-grid-color-secondary h-12 mr-5"
                                >
                                  <v-select
                                    name="phone_code"
                                    class="phone_code"
                                    label="name_with_code"
                                    :options="all_phone_codes"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    v-model="
                                      contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['ddi_phone_code']
                                    "
                                  />
                                </div>

                                <div
                                  class="w-2/3 bg-grid-color-secondary h-12 mr-5"
                                >
                                  <vs-input
                                    class="w-full"
                                    name="phone"
                                    v-model="
                                      contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['ddi']
                                    "
                                  />
                                </div>

                            
                              </div>
                            </template>
                          </template>

                          <template
                            v-else-if="
                              field_array_column.identifier == 'mobile'
                            "
                          >

                         

                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                              <div class="flex mb-4">
                                <div
                                  class="w-1/3 bg-grid-color-secondary h-12 mr-5"
                                >
                                  <v-select
                                    name="phone_code"
                                    class="phone_code"
                                    label="name_with_code"
                                    :options="all_phone_codes"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    v-model="
                                      contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['mobile_phone_code']
                                    "
                                  />
                                </div>

                                <div
                                  class="w-2/3 bg-grid-color-secondary h-12 mr-5"
                                >
                                  <vs-input
                                    class="w-full"
                                    name="phone"
                                    v-model="
                                      contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['mobile']
                                    "
                                  />
                                </div>

                            
                              </div>
                            </template>
                          </template>

                          <template
                            v-else-if="
                              field_array_column.identifier ==
                              'contact_social_media'
                            "
                          >

                          

                          
                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                              <div class="flex mb-4">
                                <div
                                  class="w-3/4 bg-grid-color-secondary h-12 mr-5"
                                >
                                  <vs-input
                                    class="w-full"
                                    name="contact_social_media"
                                    v-model="
                                      contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['social_media']
                                    "
                                    data-vv-as="contact_social_media"
                                  />
                                </div>
                                <div
                                  class="w-3/4 bg-grid-color-secondary h-12 mr-5"
                                >
                                  <vs-textarea
                                    class="w-full mb-2"
                                    v-model="
                                      contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['summary']
                                    "
                                  />
                                </div>
                               
                              </div>
                            </template>
                          </template>

                          <template
                            v-else-if="field_array_column.identifier == 'email'"
                          >
                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                              <div class="flex mb-4">
                                <div
                                  class="w-3/4 bg-grid-color-secondary h-12 mr-5"
                                >
                                  <vs-input
                                    class="w-full"
                                    name="email"
                                    v-model="
                                      contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]
                                    "
                                    data-vv-as="email"
                                  />
                                </div>
                             
                             
                              </div>
                            </template>

                          
                          </template>
                        </template>

                        <template v-else>
                          <template v-if="Array.isArray(value)">
                            <template v-for="val in value">



   

                

                          <template
                            v-if="field_array_column.identifier == 'ddi'"
                          >


                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                              <div class="flex mb-4">
                               {{ w }}
                            
                              </div>
                            </template>
                          </template>

                          <template
                            v-else-if="
                              field_array_column.identifier == 'mobile'
                            "
                          >


                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                              <div class="flex mb-4">
                               {{ w }}

                                
                            
                              </div>
                            </template>
                          </template>

                          <template
                            v-else-if="
                              field_array_column.identifier ==
                              'contact_social_media'
                            "
                          >

                          

                          

                          
                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                              <div class="flex mb-4">
                               {{ w }}
                               
                              </div>
                            </template>
                          </template>

                          <template
                            v-else-if="field_array_column.identifier == 'email'"
                          >
                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                             {{ w }}
                            </template>

                          
                          </template>

                             <template
                            v-else
                          >

                                                        {{ val }} 


                          
                          </template>



                              <br />
                            </template>
                          </template>

                          

                          <template v-else>


                            
                            <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                          </template>
                        </template>
                      </div>
                    </div>

                    <template v-else>
                      <div 
                        v-if="
                          field_array_column.identifier == 'none_core_field' &&
                          has_different_value.includes(key)
                        "
                      >
                      
                        <template v-if="Array.isArray(value)">
                          <template v-if="has_different_value.includes(key)">





                            <template
                              v-if="field_array_column.type == 'checkbox'"
                            >
                              <span
                                v-for="(v, v_key) in JSON.parse(
                                  field_array_column.values
                                )"
                                class="p-2"
                              >
                                <input
                                  type="checkbox"
                                  class="mr-2"
                                  :value="v.value"
                                  :id="field_array_column.column_id"
                                  v-model="
                                    contactDataDescription['master_db_contact'][
                                      key
                                    ]
                                  "
                                  :checked="
                                    contactDataDescription['master_db_contact'][
                                      key
                                    ] != null &&
                                    contactDataDescription['master_db_contact'][
                                      key
                                    ].includes(v.value)
                                  "
                                />

                                {{ v.value }}
                              </span>
                            </template>
                          </template>

                          <template v-else>
                            <template v-for="val in value">
                              {{ val }}
                            </template>
                          </template>
                        </template>

                        <template v-else>


                          <template v-if="field_array_column.type == 'checkbox'">
                            <span
                              v-for="(v, v_key) in JSON.parse(
                                field_array_column.values
                              )"
                              class="p-2"
                            >
                              <input
                                type="checkbox"
                                class="mr-2"
                                :value="v.value"
                                :id="field_array_column.column_id"
                                v-model="
                                  contactDataDescription['master_db_contact'][
                                    key
                                  ]
                                "
                                :checked="
                                  contactDataDescription['master_db_contact'][
                                    key
                                  ] != null &&
                                  contactDataDescription['master_db_contact'][
                                    key
                                  ].includes(v.value)
                                "
                              />

                              {{ v.value }}
                            </span>
                          </template>

                          <template v-if="field_array_column.type == 'number'">
                            <input
                              type="number"
                              class="vs-input-class"
                              v-model="
                                contactDataDescription['master_db_contact'][key]
                              "
                              :name="field_array_column.column_id"
                              :data-vv-as="field_array_column.column_id"
                            />
                          </template>

                          <template
                            v-else-if="
                              field_array_column.type == 'text' ||
                              field_array_column.type == 'client_contact'
                            "
                          >
                            <vs-input
                              class="w-full"
                              v-model="
                                contactDataDescription['master_db_contact'][key]
                              "
                              :name="field_array_column.column_id"
                              v-validate="
                                field_array_column.mandatory ? 'required' : ''
                              "
                              :data-vv-as="field_array_column.column_id"
                            />
                          </template>

                          <template
                            v-else-if="field_array_column.type == 'date'"
                          >
                            <flat-pickr
                              :config="configDateTimePicker"
                              placeholder="Choose Date"
                              name="audit_date_time"
                              v-model="
                                contactDataDescription['master_db_contact'][key]
                              "
                            />
                          </template>

                          <template
                            v-else-if="field_array_column.type == 'datetime'"
                          >
                            <flat-pickr
                              :config="configDateAndTimePicker"
                              placeholder="Choose Date And Time"
                              name="audit_date_and_time"
                              v-model="
                                contactDataDescription['master_db_contact'][key]
                              "
                            />
                          </template>

                          <template
                            v-else-if="field_array_column.type == 'choose_one'"
                          >
                            <span
                              v-for="(val, k) in JSON.parse(
                                field_array_column.values
                              )"
                            >
                              <input
                                class="ml-4"
                                :name="key"
                                :value="val.value"
                                type="radio"
                                v-model="
                                  contactDataDescription['master_db_contact'][
                                    key
                                  ]
                                "
                              />
                              {{ val.value }}
                            </span>

                            <!-- <v-select
                            label="value"
                            :name="key"
                            :options="JSON.parse(field_array_column.values)"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            v-model="contactDataDescription['master_db_contact'][key]"
                            v-validate="'required'"
                            data-vv-as="Action Type"
                          /> -->
                          </template>

                          <template
                            v-else-if="field_array_column.type == 'dropdown'"
                          >
                            <v-select
                              label="value"
                              :name="key"
                              :options="JSON.parse(field_array_column.values)"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              v-model="
                                contactDataDescription['master_db_contact'][key]
                              "
                              v-validate="'required'"
                              data-vv-as="Action Type"
                            />
                          </template>

                          <template
                            v-else-if="field_array_column.type == 'textarea'"
                          >


                            <vue-trumbowyg v-if="showComponent"
                              v-model="
                                contactDataDescription['master_db_contact'][key]
                              "
                              :config="configs.basic"
                            ></vue-trumbowyg>
                          </template>
                        </template>
                      </div>

                      <div v-else>
                        <template v-if="Array.isArray(value)">
                          <template v-if="has_different_value.includes(key)">
                            <template
                              v-if="field_array_column.type == 'checkbox'"
                            >
                              <span
                                v-for="(v, v_key) in JSON.parse(
                                  field_array_column.values
                                )"
                                class="p-2"
                              >
                                <input
                                  type="checkbox"
                                  class="mr-2"
                                  :value="v.value"
                                  :id="field_array_column.column_id"
                                  v-model="
                                    contactDataDescription['master_db_contact'][
                                      key
                                    ]
                                  "
                                  :checked="
                                    contactDataDescription['master_db_contact'][
                                      key
                                    ] != null &&
                                    contactDataDescription['master_db_contact'][
                                      key
                                    ].includes(v.value)
                                  "
                                />

                                {{ v.value }}
                              </span>
                            </template>
                          </template>

                          <template v-else>
                            <template v-for="val in value">

                           <template
                            v-if="field_array_column.identifier == 'ddi'"
                          >



          

                          
                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                              <div class="flex mb-4">
                                {{ contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['ddi_phone_code'] }}

                                {{ contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['ddi'] }}

                            
                              </div>
                            </template>
                          </template>

                          <template
                            v-else-if="
                              field_array_column.identifier == 'mobile'
                            "
                          >

                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                              <div class="flex mb-4">
                                 {{ contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['mobile_phone_code'] }}

                                 {{ contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['mobile'] }}

                            
                              </div>
                            </template>
                          </template>

                          <template
                            v-else-if="
                              field_array_column.identifier ==
                              'contact_social_media'
                            "
                          >

                          

                          
                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                              <div class="flex mb-4">
                                {{ contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['social_media'] }}
                                 {{ contactDataDescription[
                                        'master_db_contact'
                                      ][key][index]['summary'] }}
                               
                              </div>
                            </template>
                          </template>

                          <template
                            v-else-if="field_array_column.identifier == 'email'"
                          >
                            <template
                              v-for="(w, index) in contactDataDescription[
                                'master_db_contact'
                              ][key]"
                            >
                              {{ contactDataDescription[
                                        'master_db_contact'
                                      ][key][index] }}
                            </template>

                          
                          </template>

                             <template
                            v-else
                          >
                                                        {{ val }} 


                          
                          </template>
                            </template>
                          </template>
                        </template>

                        <template v-else>
                          <template
                            v-if="
                              has_different_value.includes(key) &&
                              contactDataDescription['master_db_contact'][
                                key
                              ] != null
                            "
                          >
                            <template
                              v-if="field_array_column.type == 'number'"
                            >
                              <input
                                type="number"
                                class="vs-input-class"
                                v-model="
                                  contactDataDescription['master_db_contact'][
                                    key
                                  ]
                                "
                                :name="field_array_column.column_id"
                                :data-vv-as="field_array_column.column_id"
                              />
                            </template>

                            <template
                              v-else-if="
                                field_array_column.type == 'text' ||
                                field_array_column.type == 'client_contact'
                              "
                            >
                              <template
                                v-if="
                                  field_array_column.identifier !=
                                  'none_core_field'
                                "
                              >
                                <template
                                  v-if="field_array_column.identifier == 'role'"
                                >
                                  <v-select
                                    name="role"
                                    class="role"
                                    label="role"
                                    :options="all_roles"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    v-model="
                                      contactDataDescription[
                                        'master_db_contact'
                                      ][key]
                                    "
                                  />
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier == 'sub_role'
                                  "
                                >
                                  <v-select
                                    name="sub_role"
                                    class="sub_role"
                                    label="sub_role"
                                    :options="all_sub_roles"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    v-model="
                                      contactDataDescription[
                                        'master_db_contact'
                                      ][key]
                                    "
                                  />
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier == 'seniority'
                                  "
                                >
                                  <div class="vx-col sm:w-1/3 w-full">
                                    <v-select
                                      label="seniority"
                                      :options="all_seniorities"
                                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                      v-model="
                                        contactDataDescription[
                                          'master_db_contact'
                                        ][key]
                                      "
                                    />
                                  </div>
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier == 'ddi'
                                  "
                                >


                                  <template
                                    v-for="(w, index) in contactDataDescription[
                                      'master_db_contact'
                                    ][key]"
                                  >
                                    <div class="flex mb-4">
                                      <div
                                        class="w-1/3 bg-grid-color-secondary h-12 mr-5"
                                      >
                                        <v-select
                                          name="phone_code"
                                          class="phone_code"
                                          label="name_with_code"
                                          :options="all_phone_codes"
                                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                          v-model="
                                            contactDataDescription[
                                              'master_db_contact'
                                            ][key][index]['ddi_phone_code']
                                          "
                                        />
                                      </div>

                                      <div
                                        class="w-2/3 bg-grid-color-secondary h-12 mr-5"
                                      >
                                        <vs-input
                                          class="w-full"
                                          name="phone"
                                          v-model="
                                            contactDataDescription[
                                              'master_db_contact'
                                            ][key][index]['ddi']
                                          "
                                        />
                                      </div>

                                     
                                    </div>
                                  </template>
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier == 'mobile'
                                  "
                                >


                                  <template
                                    v-for="(w, index) in contactDataDescription[
                                      'master_db_contact'
                                    ][key]"
                                  >
                                    <div class="flex mb-4">
                                      <div
                                        class="w-1/3 bg-grid-color-secondary h-12 mr-5"
                                      >
                                        <v-select
                                          name="phone_code"
                                          class="phone_code"
                                          label="name_with_code"
                                          :options="all_phone_codes"
                                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                          v-model="
                                            contactDataDescription[
                                              'master_db_contact'
                                            ][key][index]['mobile_phone_code']
                                          "
                                        />
                                      </div>

                                      <div
                                        class="w-2/3 bg-grid-color-secondary h-12 mr-5"
                                      >
                                        <vs-input
                                          class="w-full"
                                          name="phone"
                                          v-model="
                                            contactDataDescription[
                                              'master_db_contact'
                                            ][key][index]['mobile']
                                          "
                                        />
                                      </div>

                                   
                                    </div>
                                  </template>
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier ==
                                    'contact_social_media'
                                  "
                                >
                                  <template
                                    v-for="(w, index) in contactDataDescription[
                                      'master_db_contact'
                                    ][key]"
                                  >
                                    <div class="flex mb-4">
                                      <div
                                        class="w-3/4 bg-grid-color-secondary h-12 mr-5"
                                      >
                                        <vs-input
                                          class="w-full"
                                          name="contact_social_media"
                                          v-model="
                                            contactDataDescription[
                                              'master_db_contact'
                                            ][key][index]['social_media']
                                          "
                                          data-vv-as="contact_social_media"
                                        />
                                      </div>
                                      <div
                                        class="w-3/4 bg-grid-color-secondary h-12 mr-5"
                                      >
                                        <vs-textarea
                                          class="w-full mb-2"
                                          v-model="
                                            contactDataDescription[
                                              'master_db_contact'
                                            ][key][index]['summary']
                                          "
                                        />
                                      </div>
                                  
                                    </div>
                                  </template>
                                </template>

                                <template
                                  v-else-if="
                                    field_array_column.identifier == 'email'
                                  "
                                >
                                  <template
                                    v-for="(w, index) in contactDataDescription[
                                      'master_db_contact'
                                    ][key]"
                                  >
                                    <div class="flex mb-4">
                                      <div
                                        class="w-3/4 bg-grid-color-secondary h-12 mr-5"
                                      >
                                        <vs-input
                                          class="w-full"
                                          name="email"
                                          v-model="
                                            contactDataDescription[
                                              'master_db_contact'
                                            ][key][index]['email']
                                          "
                                          data-vv-as="email"
                                        />
                                      </div>
                                 
                             
                                    </div>
                                  </template>

                                
                                </template>

                                <template v-else>
                                  <vs-input
                                    class="w-full"
                                    v-model="
                                      contactDataDescription[
                                        'master_db_contact'
                                      ][key]
                                    "
                                    :name="field_array_column.column_id"
                                    v-validate="
                                      field_array_column.mandatory
                                        ? 'required'
                                        : ''
                                    "
                                    :data-vv-as="field_array_column.column_id"
                                  />
                                </template>
                              </template>

                              <template v-else>
                                <vs-input
                                  class="w-full"
                                  v-model="
                                    contactDataDescription['master_db_contact'][
                                      key
                                    ]
                                  "
                                  :name="field_array_column.column_id"
                                  v-validate="
                                    field_array_column.mandatory
                                      ? 'required'
                                      : ''
                                  "
                                  :data-vv-as="field_array_column.column_id"
                                />
                              </template>
                            </template>

                            <template
                              v-else-if="field_array_column.type == 'date'"
                            >
                              <flat-pickr
                                :config="configDateTimePicker"
                                placeholder="Choose Date"
                                name="audit_date_time"
                                v-model="
                                  contactDataDescription['master_db_contact'][
                                    key
                                  ]
                                "
                              />
                            </template>

                            <template
                              v-else-if="field_array_column.type == 'datetime'"
                            >
                              <flat-pickr
                                :config="configDateAndTimePicker"
                                placeholder="Choose Date And Time"
                                name="audit_date_and_time"
                                v-model="
                                  contactDataDescription['master_db_contact'][
                                    key
                                  ]
                                "
                              />
                            </template>

                            <template
                              v-else-if="
                                field_array_column.type == 'choose_one'
                              "
                            >
                              <span
                                v-for="(val, k) in JSON.parse(
                                  field_array_column.values
                                )"
                              >
                                <input
                                  class="ml-4"
                                  :name="key"
                                  :value="val.value"
                                  type="radio"
                                  v-model="
                                    contactDataDescription['master_db_contact'][
                                      key
                                    ]
                                  "
                                />
                                {{ val.value }}
                              </span>

                              <!-- <v-select
                            label="value"
                            :name="key"
                            :options="JSON.parse(field_array_column.values)"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            v-model="contactDataDescription['master_db_contact'][key]"
                            v-validate="'required'"
                            data-vv-as="Action Type"
                          /> -->
                            </template>

                            <template
                              v-else-if="field_array_column.type == 'dropdown'"
                            >
                              <v-select
                                label="value"
                                :name="key"
                                :options="JSON.parse(field_array_column.values)"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                v-model="
                                  contactDataDescription['master_db_contact'][
                                    key
                                  ]
                                "
                                v-validate="'required'"
                                data-vv-as="Action Type"
                              />
                            </template>

                            <template
                              v-else-if="field_array_column.type == 'textarea'"
                            >
                              <vue-trumbowyg :key="componentKey"
                                v-model="
                                  contactDataDescription['master_db_contact'][
                                    key
                                  ]
                                "
                                :config="configs.basic"
                              ></vue-trumbowyg>
                            </template>
                          </template>

                          <template v-else>

                            <div :style="field_array_column.field_type == 'textarea'? 'height: ' + (value.length / 2) + 'px;' : 'height:100px;'">
                            {{ value }}


                            </div>
                            
                            
                          </template>

                          <!-- {{ value }}   -->
                        </template>
                      </div>
                    </template>
                  </template>
                </template>
              </div>
              <vs-divider class="p-5" />
            </vs-col>
          </template>
        </vs-col>
      </vs-row>

      <div class="text-center">
                <vs-button class="m-10"  @click.prevent="ignoreMasterDBContactFromValidateSDContact">Ignore</vs-button>


                <vs-button  @click.prevent="submitForm">Submit</vs-button>
      </div>
    </vs-popup>

    <vs-popup
      title="Imported SD Contact Data To Master Database"
      style="z-index: 999999"
      class="holamundo"
      :active.sync="importExcelDataToMasterDatabasePopUp"
      :button-close-hidden="true"
      @close="closeimportExcelDataToMasterDatabasePopUp"
    >
      <vs-row class="p-2">
        <vs-col vs-type="flex" vs-w="3">
          <vs-col vs-type="flex" vs-w="12">
            <u><h5>Matched</h5></u>
          </vs-col>
        </vs-col>

        <vs-col vs-type="flex" vs-w="3">
          <vs-col vs-type="flex" vs-w="12">
            <u><h5>Count</h5></u>
          </vs-col>
        </vs-col>
      </vs-row>

      <template v-for="(value, key) in count_matched_contacts">
        <vs-row class="p-2">
          <vs-col vs-type="flex" vs-w="3">
            <vs-col vs-type="flex" vs-w="12">
              {{ value['added_through'] }}
            </vs-col>
          </vs-col>

          <vs-col vs-type="flex" vs-w="3">
            <vs-col vs-type="flex" vs-w="12">
              {{ value['count'] }}
            </vs-col>
          </vs-col>
        </vs-row>
      </template>

      <div class="text-center mt-5">
        <vs-button @click="finished">Finish</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moduleCampaignsManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import moduleContactsManagement from '@/store/contacts-management/moduleContactsManagement.js'
import DataGrid from '@/components/aggrid/Aggrid.vue'
import defineAbilitiesFor from '@/config/abilities'
import axios from '@/axios.js'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import VueTrumbowyg from 'vue-trumbowyg'
import 'jquery-resizable-dom/dist/jquery-resizable.js'
import 'jquery-resizable-dom/dist/jquery-resizableTableColumns.js'

import 'trumbowyg/dist/trumbowyg.min.js'
import 'trumbowyg/dist/ui/trumbowyg.min.css'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js'
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css'
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js'
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.min.js'
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min.js'
import 'trumbowyg/dist/plugins/preformatted/trumbowyg.preformatted.min.js'
import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js'
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.js'
import moduleAccountsManagement from '@/store/accounts-management/moduleAccountsManagement.js'

export default {
  data: () => ({
      showComponent: true,
    configDateTimePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d'
    },
    configDateAndTimePicker: {
      enableTime: true,
      dateFormat: 'Y-m-d H:i:s',
      enableSeconds: true
    },
    configs: {
      basic: {
        autogrow: true,
        removeformatPasted: true,
        btns: [
          ['strong', 'em'],
          ['superscript', 'subscript'],
          ['fontsize'],
          ['foreColor', 'backColor'],
          ['link'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['horizontalRule'],
          ['removeformat'],
          ['fullscreen']
        ],
        plugins: {
          table: {
            columns: 10,
            rows: 10
          },
          resizimg: {
            minSize: 64,
            step: 16
          }
        }
      }
    },
    all_seniorities: [],
    all_roles: [],
    all_sub_roles: [],
    all_currency_codes: [],
    all_verticals: [],
    all_sic_codes: [],
    all_countries: [],
    all_phone_codes: [],
    all_field_datas: {},
    user_id: null,
    count_matched_contacts: [],
    importExcelDataToMasterDatabasePopUp: false,
    closeimportExcelDataToMasterDatabasePopUp: false,
    campaignName: null,
    has_different_value: [],
    configDateTimePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d'
    },
    review_changes: [],
    match_contacts: [],
    total_pages: 0,
    limit: 10,
    currentx: 1,
    paginate: { limit: 10, offset: 0 },
    contacts: {
      master_ddi: [],
      master_email: [],
      site_email: [],
      master_site_email: null,
      company_name: null,
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      head_office_country: null,
      company_registration_number: null,
      registration_jurisdiction: null,
      status: null,
      parent: null,
      web: [],
      master_web: null,
      master_contact_social_media: null,
      ddi: null,
      contact_social_media: [],
      country: null,
      revenue: null,
      no_of_employees: null
    },
    contactDataDescription: {},
    enrichContactDataToMasterDBPopUp: false,
    enrichOtherFieldContactDataToMasterDBPopUp: false,
    abilities: null,
    table_name: null,
    log: [],
    dataSource: {},
    campaignDescription: [],
    enrichContactDataToMasterDB: [],
    selected_contact_fields: [],
    updated_contact_description: []
  }),
  components: {
    'v-select': vSelect,
    DataGrid,
    flatPickr,
    VueTrumbowyg
  },
  watch: {
    currentx: function (val, oldVal) {
      this.paginate = { limit: 10, offset: (val - 1) * this.limit }
      this.ValidateSDContactDataWithMasterDBView()
    }
  },
  methods: {
    removeDuplicates (arr) {
      let unique = arr.reduce(function (acc, curr) {
        if (!acc.includes(curr)) acc.push(curr)
        return acc
      }, [])
      return unique
    },
    toggleConfirmedStatus (val, toggle, key) {
      console.log(val)
      console.log(toggle)
      console.log(key)

      if (Array.isArray(this.updated_contact_description[key])) {
        if (toggle == true) {
          this.updated_contact_description[key].push(val)
        } else {
          this.updated_contact_description[key] =
            this.updated_contact_description[key].filter(function (
              value,
              index,
              arr
            ) {
              return value != val
            })
        }

        this.updated_contact_description[key] = this.removeDuplicates(
          this.updated_contact_description[key]
        )

        console.log(
          'updated_contact_description',
          this.updated_contact_description[key]
        )
      } else {
        if (toggle == true) {
          this.updated_contact_description[key] = val
        } else {
          this.updated_contact_description[key] = null
        }
      }

      console.log(
        'updated_contact_description',
        this.updated_contact_description[key]
      )
    },
    refreshComponent() {
      this.showComponent = false; // Unmount the component
      this.$nextTick(() => {
        this.showComponent = true; // Remount the component
      });
    },

    acceptToUpdate (data) {

      this.refreshComponent()

      this.contactDataDescription = data

      this.updated_contact_description = data['updated_csv']

      this.has_different_value =
        this.contactDataDescription['has_different_value']

      for (let key in this.contactDataDescription['master_db_contact']) {
        if (
          this.contactDataDescription['master_db_contact'][key] == null ||
          this.contactDataDescription['master_db_contact'][key] == ''
        ) {
          this.contactDataDescription['master_db_contact'][key] = null
        }

        if (Array.isArray(this.contactDataDescription['master_db_contact'][key])) {
          if (
            this.contactDataDescription['master_db_contact'][key].length == 0
          ) {
            this.contactDataDescription['master_db_contact'][key] = []
          }
          else{
            this.contactDataDescription['master_db_contact'][key] =
            this.removeDuplicates(
              this.contactDataDescription['master_db_contact'][key]
            )

          }
          
        }
      }



      this.enrichContactDataToMasterDBPopUp = true
    },
    submitForm () {
      let new_data = {}

      let self = this
      this.$vs.loading()

      for (let key in this.contactDataDescription['master_db_contact']) {
        if (this.contactDataDescription['has_different_value'].includes(key)) {
          if (
            this.contactDataDescription['master_db_contact'][key] == 'EMPTY'
          ) {
            this.contactDataDescription['master_db_contact'][key] = null
          }

          new_data[key] = this.contactDataDescription['master_db_contact'][key]
        }
      }

      new_data['campaignId'] = this.campaignId
      new_data['contact_id'] = this.contactDataDescription['contact_id']
      new_data['id'] = this.contactDataDescription['id']
      new_data['account_contact_id'] = this.contactDataDescription['master_db_contact']['account_contact_id']


      console.log('new_data', new_data)
    // return false

      this.$store
        .dispatch(
          'contactsManagement/updateMasterDBContactFromSDValidate',
          new_data
        )
        .then(res => {
          if (res.data.status == 'success') {
            this.$vs.notify({
              color: 'success',
              title: 'Contact Updated',
              text: 'The contact was enriched successfully.'
            })
            // this.matchedData()

            // self.enrichContactDataToMasterDBPopUp = false
            location.reload()

            // this.matchedData();
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    finished () {
      this.importExcelDataToMasterDatabasePopUp = false

      this.$router
        .push('/contacts/compareNewExcelDataToMasterDb/' + this.campaignId)
        .catch(() => {})

      // this.$router
      //   .push("/contacts/matched/" + this.campaignId + '/' + btoa(this.campaignName))
      //   .catch(() => { });
    },
    ignoreMasterDBContactFromValidateSDContact (data) {
      let self = this


      let formData = {}
      formData.contact_id = this.contactDataDescription.contact_id
      formData.campaignId = this.campaignId

      this.$store
        .dispatch('contactsManagement/ignoreMasterDBContactFromValidateSDContact', formData)
        .then(res => {
          if (res.data.status == 'success') {
            this.$vs.notify({
              color: 'success',
              title: 'Contact Ignored',
              text: 'This contact has been ignored.'
            })
            this.$router.go()
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    goBack: function () {
      this.$router.go(-1)
    },
    formatUploadedHeader (s) {
      if (typeof s !== 'string') return ''
      if (s.startsWith('ml_')) return ''
      if (s === 'master_db_contact') return ''
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("_", " ");
      // s = s.replace("slave", " ");
      // s = s.replace("ml", " ");
      return s
    },
    ValidateSDContactDataWithMasterDBView () {
      let self = this
      this.$vs.loading()
      this.paginate.campaignId = this.campaignId
      axios
        .post(
          this.$base_url + '/api/campaigns/validate_sd_contact_data_with_master_db_view',
          this.paginate
        )
        .then(response => {
          this.match_contacts = JSON.parse(response.data).rows

          if (this.match_contacts.length != 0) {
            this.selected_contact_fields = JSON.parse(
              response.data
            ).sd_contact_table_name_data

            let total = JSON.parse(response.data).total_pages
            this.total_pages = Math.ceil(total / this.limit)
            this.$vs.loading.close()

            console.log(this.match_contacts)
          } else {
            self.$vs.loading.close()

            self.$router
              .push(
                '/contacts/matched/' +
                  self.$route.params.campaignId +
                  '/' +
                  btoa(self.campaignName)
              )
              .catch(() => {})
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    sendCompletedEmail (message, subject) {
      let self = this
      let data = {}
      data.user_id = self.user_id
      data.message = message
      data.subject = subject
      axios
        .post(self.$base_url + '/api/contacts/send_completed_email', data)
        .then(response => {
          if (response.data.status == 'success') {
            self.$vs.notify({
              color: 'success',
              title: 'Data Validation',
              text: 'The data validation email has been sent successfully.'
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateHasDifferentValueAfterUpdate () {
      let self = this
      let data = {}
      data.campaignId = self.$route.params.campaignId
      this.$store
        .dispatch('contactsManagement/updateHasDifferentValueAfterUpdate', data)
        .then(res => {
          if (res.data.status == 'success') {
            if (res.data.data > 0) {
              let link =
                '/contacts/compareNewExcelDataToMasterDb/' +
                self.$route.params.campaignId
              let message =
                'There are ' +
                res.data.data +
                ' contacts with different values after update. Please review with the link below: <br> <a href ="' +
                window.location.origin +
                link +
                '" target="_blank"> Review Contacts</a>'

              let subject = 'Contacts with Different Values After Update'

              self.sendCompletedEmail(message, subject)
            } else {
              let message =
                "There are no contacts with different values after update. Please click on the link below to view the contacts on the campaign: <br> <a href ='" +
                window.location.origin +
                '/accounts/matched/' +
                self.$route.params.campaignId +
                '/' +
                btoa(self.campaignName) +
                "' target='_blank'>View Campaign Contacts</a>"

              let subject = 'Contacts with Different Values After Update'

              self.sendCompletedEmail(message, subject)
            }
          } else {
            let message =
              'There is something wrong with the update. Please contact support team.'

            let subject = 'Contacts with Different Values After Update'

            self.sendCompletedEmail(message, subject)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    getImportedExcelDataToMasterDBRecords () {
      let self = this
      let data = {}
      data.campaignId = this.$route.params.campaignId
      this.$store
        .dispatch(
          'campaignsManagement/getImportedExcelDataToMasterDBRecords',
          data
        )
        .then(res => {
          self.count_matched_contacts = JSON.parse(res.data)

          // self.importExcelDataToMasterDatabasePopUp = true;

          console.log(self.count_matched_contacts)
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true
            return
          }
          console.error(err)
        })
    },

    getCampaignDescription () {
      const campaignId = this.$route.params.campaignId
      this.$store
        .dispatch('campaignsManagement/fetchCampaign', campaignId)
        .then(res => {
          this.campaignDescription = res.data
          this.campaignName = this.campaignDescription.campaign_name
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = true
            return
          }
          console.error(err)
        })
    },
    getAllSeniority () {
      this.$store
        .dispatch('contactsManagement/getSeniority')
        .then(res => {
          this.all_seniorities = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            console.error(err)
          }
        })
    },
    getAllRoles () {
      this.$store
        .dispatch('contactsManagement/getRoles')
        .then(res => {
          this.all_roles = res.data
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
    getAllSubRole (role_id) {
      this.$store
        .dispatch('contactsManagement/getSubRoles', role_id)
        .then(res => {
          this.all_sub_roles = res.data
        })
        .catch(err => {
          console.error(err)
        })
    },
        getAllPhoneCodes () {
      let self = this
      this.$store
        .dispatch('accountsManagement/getAllPhoneCodes')
        .then(response => {
          self.all_phone_codes = response.data
          self.all_countries = response.data
          self.all_phone_codes.forEach(function(ele){
            if(ele.phone_code){
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
  },
  mounted () {
    this.getCampaignDescription()
    this.ValidateSDContactDataWithMasterDBView()
    this.getAllRoles()
    this.getAllSeniority()
    this.getAllSubRole()
    this.getAllPhoneCodes()
  },
  created () {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    })
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.user_id = userInfo['uid']

    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        'campaignsManagement',
        moduleCampaignsManagement
      )
      moduleCampaignsManagement.isRegistered = true
    }

     if (!moduleAccountsManagement.isRegistered) {
      defineAbilitiesFor().then(function (data) {
        self.abilities = data
      })
      this.$store.registerModule('accountsManagement', moduleAccountsManagement)
      moduleAccountsManagement.isRegistered = true
    }

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule('contactsManagement', moduleContactsManagement)
      moduleContactsManagement.isRegistered = true
    }
    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule('contactsManagement', moduleContactsManagement)
      moduleContactsManagement.isRegistered = true
    }
    this.campaignId = this.$route.params.campaignId

    // this.getAssocaitedContactsContacts();
  }
}
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.width_class {
  width: 580px;
}

.imput_field {
  width: 500px;
}

textarea{
  display: none;
}


.accept-button {
  cursor: pointer;
}

.row-height_with_size {
  height: 400px !important;
  background-color: #f5f5f5 !important;
  padding: 15px;
}
</style>

<style lang="stylus">

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
    padding: .75rem 1rem;
}

.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
